import Rete from 'rete'
import { nanoid } from 'nanoid/async'

import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import { newPostbackModal } from './newPostbackModal'
import {
  removeNodes,
  updateNodeConnections,
  addNewSequenceToEditor,
  addNewPostbackNodeToEditor,
  addNewSequenceSingleToEditor,  
  fixYPositionOfChildComponents,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data
  const { 
    value: newPostbackData, 
    isConfirmed: isClickedOkButton,
  } = await newPostbackModal(oldData, node)

  if (newPostbackData && Object.values(newPostbackData).length > 0) {
    // Create post-back ID if there is not any
    if (! ('postbackId' in node.data)) {
      node.data.title = newPostbackData.title
      node.data.postbackId = await nanoid(15)
    }
    
    Object.assign(node.data, newPostbackData)

    if ('newSequence' === newPostbackData.sequenceIdValue) {
      node.newPostbackNodeSequenceSocketStatus = false
      if (node.outputs instanceof Map) {
        const newPostbackOutputSequence = node.outputs.get(CONST_SOCKET.NEW_POSTBACK_OUTPUT_SEQUENCE)
        if (newPostbackOutputSequence instanceof Rete.Output) {
          if (0 === newPostbackOutputSequence.connections.length) {
            attachNewSequenceAndChildrenToNewPostbackNode(node)
          }
        }
      }
    }

    if ('newSequence' !== newPostbackData.sequenceIdValue) {
      node.newPostbackNodeSequenceSocketStatus = true
      if (isClickedOkButton && node.newPostbackNodeNewSequenceValueChangeStatus) {
        if (node.newPostbackNodeChildrenComponents 
          && node.newPostbackNodeChildrenComponents instanceof Map
        ) {
          const nodesList = node.newPostbackNodeChildrenComponents.get('node-id-' + node.id)
          
          if (nodesList) {
            removeNodes(nodesList)
            node.newPostbackNodeChildrenComponents.delete('node-id-' + node.id)
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)
  }

  return false
}

const attachNewSequenceAndChildrenToNewPostbackNode = async (node) => {
  const newSequenceNodePosition = [node.position[0] + 250, node.position[1] + 40]
  const newSequenceNode = await addNewSequenceToEditor(newSequenceNodePosition)

  const nodeList = [newSequenceNode]

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.NEW_POSTBACK_OUTPUT_SEQUENCE),
    newSequenceNode.inputs.get(CONST_SOCKET.SEQUENCE_INPUT)
  )

  const items = [1, 2, 3]
  
  // eslint-disable-next-line
  items.map(async (item, index) => { 
    const sequenceSingleNodePositionY = fixYPositionOfChildComponents(index, 90, items.length)
    const squenceSingleNodePosition = [node.position[0] + 500, sequenceSingleNodePositionY]
    const sequenceSingleNode = await addNewSequenceSingleToEditor(squenceSingleNodePosition)

    nodeList.push(sequenceSingleNode)

    const childNewPostbackNodePositionY = fixYPositionOfChildComponents(index, 112, items.length)
    const childNewPostbackNodePosition = [node.position[0] + 750, childNewPostbackNodePositionY]
    const childNewPostbackNode = await addNewPostbackNodeToEditor(childNewPostbackNodePosition)

    nodeList.push(childNewPostbackNode)

    App.editor.connect(
      newSequenceNode.outputs.get(CONST_SOCKET.SEQUENCE_OUTPUT),
      sequenceSingleNode.inputs.get(CONST_SOCKET.SEQUENCE_SINGLE_INPUT)
    )

    App.editor.connect(
      sequenceSingleNode.outputs.get(CONST_SOCKET.SEQUENCE_SINGLE_OUTPUT),
      childNewPostbackNode.inputs.get(CONST_SOCKET.NEW_POSTBACK_INPUT)
    )
  })

  const componentsMap = new Map()
  componentsMap.set('node-id-' + node.id, nodeList)
  node.newPostbackNodeChildrenComponents = componentsMap
}